import GetVacancies from '@/services/cms/vacancyService/GetVacancies';

export default class VacancyService {
    async getVacancies() {
        return (new GetVacancies()).handle();
    }
}
